import { ProductoAcuerdo } from './producto-acuerdo.model';
import { TipoMoneda } from '../cliente/operaciones/tipoMoneda.model';
import { TipoImpresion } from '../productos/tipo-impresion/tipo-impresion.model';

export class TarifarioAdicional {

  precio: number;
  tipoImpresion: TipoImpresion;

  constructor(tipo) {
    this.tipoImpresion = tipo;
  }



}



// WEBPACK FOOTER //
// ./src/app/acuerdo/tarifario-adicional.model.ts